export function CloseIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19.207 6.207a1 1 0 10-1.414-1.414l-5.8 5.8-5.849-5.75A1 1 0 104.742 6.27l5.837 5.736-5.786 5.787a1 1 0 101.414 1.414l5.799-5.799 5.85 5.748a1 1 0 101.401-1.426l-5.837-5.736 5.787-5.787z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
